import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AnimatedBackground } from './components/AnimatedBackground';
import { HeroSection } from './components/HeroSection';
import { AudioSampleSection } from './components/AudioSampleSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductShowcaseSection } from './components/ProductShowcaseSection';
import { TestimonialSection } from './components/TestimonialSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CTASection } from './components/CTASection';
import { LegalModals } from './components/LegalModals';
import { ShoppingCart, Shield, Zap, CheckCircle } from 'lucide-react';
export function App() {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return <div className="min-h-screen text-white selection:bg-[#D4AF37] selection:text-black overflow-x-hidden relative" data-id="element-0">
      {/* 3D Animated Background */}
      <AnimatedBackground data-id="element-1" />

      {/* Legal Modals */}
      <LegalModals termsOpen={termsOpen} privacyOpen={privacyOpen} onCloseTerms={() => setTermsOpen(false)} onClosePrivacy={() => setPrivacyOpen(false)} data-id="element-2" />

      {/* Main Content */}
      <div className="relative z-10" data-id="element-3">
        <main data-id="element-4">
          <HeroSection data-id="element-5" />
          <AudioSampleSection data-id="element-6" />
          <BenefitsSection data-id="element-7" />
          <ProductShowcaseSection data-id="element-8" />
          <TestimonialSection data-id="element-9" />
          <ObjectionsSection data-id="element-10" />
          <GuaranteeSection data-id="element-11" />
          <CTASection data-id="element-12" />
        </main>

        {/* Order Section */}
        <section id="order-section" className="py-16 md:py-24 relative" data-id="element-13">
          <div className="max-w-4xl mx-auto px-6" data-id="element-14">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="flex flex-col items-center text-center" data-id="element-15">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-16">
                ¿Listo para transformar tu vida?
              </h2>

              <motion.a href="https://pay.hotmart.com/M104286251F?bid=1770346803141" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} className="group inline-flex flex-col items-center justify-center px-12 py-6 rounded-xl bg-gradient-to-r from-[#D4AF37] to-[#F5D76E] shadow-[0_8px_30px_rgba(212,175,55,0.4)] hover:shadow-[0_12px_40px_rgba(212,175,55,0.5)] transition-shadow duration-300" data-id="element-17">
                <div className="flex items-center gap-3" data-id="element-18">
                  <ShoppingCart className="w-6 h-6 text-[#0A0A0A]" data-id="element-19" />
                  <span className="text-xl md:text-2xl font-black text-[#0A0A0A]" data-id="element-20">
                    ¡Quiero ordenar mi Caos!
                  </span>
                </div>
                <span className="text-3xl md:text-4xl font-black text-[#0A0A0A] mt-2" data-id="element-21">
                  $111.19 MXN
                </span>
              </motion.a>
            </motion.div>
          </div>

          {/* Trust badges - positioned in bottom right corner */}
          <div className="absolute bottom-4 right-4 md:bottom-6 md:right-6" data-id="element-22">
            <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-23">
              <span className="flex items-center gap-1" data-id="element-24">
                <Shield className="w-3 h-3 text-[#D4AF37]/60" data-id="element-25" />
                Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-26">
                <Zap className="w-3 h-3 text-[#D4AF37]/60" data-id="element-27" />
                Acceso inmediato
              </span>
              <span className="hidden sm:flex items-center gap-1" data-id="element-28">
                <CheckCircle className="w-3 h-3 text-[#D4AF37]/60" data-id="element-29" />
                Garantía 30 días
              </span>
            </div>
          </div>
        </section>

        <footer className="py-8 bg-[#0A0A0A]/80 backdrop-blur-sm border-t border-[#D4AF37]/10" data-id="element-30">
          <div className="max-w-4xl mx-auto px-6" data-id="element-31">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-32">
              <p className="text-gray-600 text-sm" data-id="element-33">
                © {new Date().getFullYear()} Sistema Anticaos™. Todos los
                derechos reservados.
              </p>

              <div className="flex items-center gap-6" data-id="element-34">
                <button onClick={() => setTermsOpen(true)} className="text-sm text-gray-500 hover:text-[#D4AF37] transition-colors" data-id="element-35">
                  Términos y Condiciones
                </button>
                <button onClick={() => setPrivacyOpen(true)} className="text-sm text-gray-500 hover:text-[#D4AF37] transition-colors" data-id="element-36">
                  Política de Privacidad
                </button>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>;
}